<template>
  <div class="w100 accrual serve-center">
    <div class="w100 accrual-head po-a" :style="{ 'background-image': `url(${baseUrl}images/hcxy-accrualBasis-bg.png)` }">
      <div class="w120 mc font-40 pl10 page-name" style="padding-top: 83px;">权责清单</div>
    </div>

    <div class="w120 accrual-main po-r">
      <!--<div class="w100 flex-box" style="height: 0px">-->
        <!--&lt;!&ndash;<div class="tab-item" :class="active == 'dept' ? 'active' : ''" @click="changeTab('dept')">按部门</div>&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="tab-item" :class="active == 'serve' ? 'active' : ''" @click="changeTab('serve')">按服务</div>&ndash;&gt;-->
      <!--</div>-->

      <div class="w100 pb20 flex-box">
        <div class="left-nav card-shadow" style="border-radius: 5px;overflow: hidden" v-loading="leftLoading">

          <div >

            <div v-if="active == 'serve'" >
              <el-input
                      class="ml20 w80 mt10"
                      placeholder="请输入服务名称"
                      style="background: #ccc"
                      v-model="serveName">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <div class="left-nav-link" :class="curServeId == item.serveId ? 'active' : ''"
                   v-for="(item, index) in serveListFilter" :key="index"
                   @click="changeId(item.serveId)">
                <div class="left-nav-link-inner">
                  <div class="left-nav-link-inner-icon fl" :class="{'borderR card-shadow':item.serveId}">
                   <img :src="item.serveId?item.serveUrl:`${baseUrl}images/all_icon.png`" />
                  </div>
                  <div class="left-nav-link-inner-name fl">
                    {{ item.serveName }}
                  </div>
                  <div class="left-nav-link-inner-count fl">
                    （{{ item.cnt }}）
                  </div>


                </div>
              </div>
              <div v-if="serveListFilter.length==0" class="no-data">无查询结果。</div>
            </div>
            <div v-if="active == 'dept'" class="left-st dept-tree">
              <treeMenu
                      treeWidth="200px"
                      style="width: 100%"
                      ref="treeMenu"
                      initId="0"
                      :showShadow="false"
                      :isEdit="true"
                      loadStyle="staticLoad"
                      @nodeClick="nodeClick"
                      :showBox="false"
                      :showArrow="false"
              ></treeMenu>
            </div>
          </div>
        </div>

        <div class="flex-1 card-shadow" style="padding: 20px 60px;background: #FFFFFF;border-radius: 5px;overflow: hidden" v-loading="loading">
          <!--<div class="flex-1" v-if="(active == 'dept'&&paramSearch.deptId)||(active == 'serve'&&paramSearch.serveId)">-->
            <div class="flex-1">
          <div class="flex-box">
          <span class="font-14 pt10">关联部门：</span>
          <div class="flex-1" v-if="deptList.length">
          <span class="dept-item" :class="searchDeptId == item.deptId ? 'active' : ''"
                v-for="(item, index) in deptList" :key="index"
                @click="changeDeptId(item.deptId)">{{ item.deptName }}</span>
          </div>
            <div class="flex-1" v-else
                 style="padding-top: 10px;font-weight: 700;color: #ccc;">
              无关联部门
            </div>
          </div>

          <div class="mt20 list-warp" style="height: 600px;overflow: auto">
            <ul>
              <li class="detail-item" v-for="(item, index) in list" :key="index">
                <ul>
                  <li class="cl-f">
                    <span class="rights-label">部门名称：</span>
                    <div class="rights-con rights-con-l">{{ ((item.depts||[]).map(i=>i.deptName)).join("、") }}</div>
                  </li>
                  <li class="cl-f">
                    <span class="rights-label">岗位名称：</span>
                    <div class="rights-con rights-con-l">{{ ((item.roles||[]).map(i=>i.roleName)).join("、") }}</div>
                  </li>
                  <li class="cl-f ql-container ql-snow bor-none">
                    <span class="rights-label">权利说明：</span>
                    <div class="rights-con content-str ql-editor" v-html="item.rights"></div>

                  </li>
                  <li class="cl-f ql-container ql-snow bor-none">
                    <span class="rights-label">责任说明：</span>
                    <div class="rights-con content-str ql-editor" v-html="item.responseblity"></div>
                  </li>
                  <li class="cl-f" style="padding: 0;padding-top: 8px">
                    <div class="bg-w serve-listul">
                      <ul>
                        <li v-for="pro in (item.serves)" v-show="pro.serveName">
                          <div class="pro-name" v-text="pro.serveName"></div>
                          <div class="pro-btn">
                            <span @click="goHref(pro.serveId,'/ServeCenterDetail')">办事指南</span>
                            <span v-if="pro.applyType==1||pro.applyType==3"
                            @click="HandleApply(pro.processDefId)">在线办理</span>
                            <span v-else
                                 class="disabled">在线办理</span>
                            <span @click="goHref(pro.serveId,'/serveEvaluate')">评价</span>
                            <span @click="favorOrRecall(pro)">{{pro.tagType?'取消收藏':'收藏'}}</span>
                          </div>

                        </li>
                      </ul>

                    </div>
                  </li>

                </ul>
              </li>
            </ul>

            <div v-if="list.length==0" class="no-data">无查询结果。</div>
          </div>
          </div>
          <div class="mt20 flex-box pr20" v-show="list.length">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    import treeMenu from "@/components/treeMenu/index.vue";
    import { favorOrRecall} from '@/api/serveCenter/serveCenter';
    import { homeChargePage,homeChargeDeptList,homeChargeDeptTree,homeChargeServeVoList} from '@/api/homeCharge/homeCharge';
    import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';
    export default {
        name: "AccrualBasis",
        components: {
            treeMenu
        },
        props: [],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                serveList:[],
                serveName:'',
                curServeId: null,
                searchDeptId:'',
                active: "dept",
                deptList:[],
                list:[],
                leftLoading:false,
                loading: false,
                paramSearch:{
                    current:1,
                    size:10,
                    mDeptId:'',
                    serveId:'',
                    deptId:'',
                },
                total:0
            };
        },
        computed: {
            serveListFilter(){
                if(this.serveName){
                    return this.serveList.filter(i=>{
                        return i.serveName.indexOf(this.serveName)>-1;
                    })
                }else{
                    return this.serveList;
                }

            }
        },
        created() {},
        mounted() {

            this.homeChargeServeVoListFn();
            this.getHomeChargeDeptList("","");
        },
        destroyed() {},
        methods: {
            favorOrRecall(item){
                const params={
                    isFavor:item.tagType?false:true,
                    serveId:item.serveId
                }
                this.loading = true;
                favorOrRecall(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success( !item.tagType?"收藏成功!" :"取消收藏成功!");
                        item.tagType=item.tagType?null:true;
                    }else{
                        this.$message.warning( data.msg||"操作失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })
            },
            HandleApply(processDefId){
                bpmnStartProcess({processDefId}).then(({data})=>{
                    if(data.code==0){
                        window.open(data.data.url);
                    }else{
                        this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
                    }

                }).catch(err=>{
                    this.$message.error("服务异常" );
                })


            },
            goHref(id,name){
                let routeData = this.$router.resolve({
                    name,
                    query: {id}
                });
                window.open(routeData.href);
            },

            nodeClick(obj){
                this.getHomeChargeDeptList(obj.id,'');
            },
            getHomeChargeDeptList(deptId,serveId){


                let params={deptId,serveId}

                homeChargeDeptList(params).then(({data})=>{
                    if(data.code == 0){
                        this.deptList = data.data||[];
                        this.searchDeptId = '';
                        this.paramSearch={
                            current:1,
                                size:10,
                                mDeptId:this.searchDeptId,
                                serveId,
                                deptId
                        },

                        this.getListFn()
                    }
                }).catch(err=>{
                })

            },

            // 获取查询列表
            homeChargeServeVoListFn () {
                this.leftLoading = true;
                homeChargeServeVoList().then(({data})=> {
                    this.leftLoading = false;
                    if(data.code == 0){
                        this.serveList = data.data|| []
                    }
                })
                    .catch(() => {
                        this.leftLoading = false;
                    });
            },
            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            // 获取查询列表
            getListFn () {
                this.loading = true;
                homeChargePage(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    }
                }).catch(() => {
                        this.loading = false;
                    });
            },
            changeTab(value) {
                this.active = value;
                if(value=='serve'){

                }else{
                    this.curServeId=null
                }
                this.getHomeChargeDeptList("","");

            },
            changeId(id) {
                this.curServeId=id
                this.getHomeChargeDeptList("",id);
            },
            changeDeptId(id) {
                if(this.searchDeptId == id){
                    this.searchDeptId = '';
                }else{
                    this.searchDeptId = id;
                }
                this.paramSearch.size=10;
                this.paramSearch.current=1;
                this.paramSearch.mDeptId=this.searchDeptId;
                this.getListFn()
            }
        },
        watch: {
        },
        filters: {},
    };
</script>

<style scoped lang="less" >
  /*@import "../../assets/css/handleBtn.less";*/
  li.ql-container{
    min-height: 0px!important;

  }
  div.ql-editor{
    padding: 0px!important;
  }
  .accrual{
    background: #F2F3F6;

    &-main {
      margin: 100px auto 0 auto;
      // margin: 0 auto;
      .tab-item {
        width: 300px;
        height: 60px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        font-size: 20px;
        background: rgba(255, 255, 255, 0.2);
        cursor: pointer;
        &.active {
          color: #333333;
          background: #ffffff;
        }
      }
    }
    .left-nav {
      margin-right: 20px;
      padding: 12px 0;
      width: 214px;
      background: #fff;
      margin-left: 10px;
      &-search{
        position: absolute;
        top:0px;
        width: 100%;
      }

      &-link {
        margin: 10px 0;
        position: relative;

        &-inner{
          height: 50px;
          font-size: 16px;
          line-height: 50px;
          cursor: pointer;
          width: 200px;
          left: 21px;
          border-bottom-left-radius: 50px;
          border-top-left-radius: 50px;
          position: relative;

          &-icon{
            /*background: #F1F3F4;*/
            margin-top: 12px;
            width: 25px;
            height: 25px;
            margin-left: 12px;
            overflow: hidden;
            &.borderR{
              border-radius: 13px;
            }
            >img{
              width: 100%;
              vertical-align: top;
            }
          }
          &-name{
            width: 110px;
            text-align: left;
            padding-left: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #7c7857;

          }
          &-count{
            color: #0B4470;
          }

        }
        &.active {
          .left-nav-link-inner{
            color: #ffffff;
            background: rgba(73, 164, 240, 1);
            z-index: 1;
            &-name{
              color: #fff;
            }
            &-count{
              color: #fff;
            }
          }

          &:after {
            content: '';
            display: block;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            position: absolute;
            bottom: -8px;
            z-index: 0;
            border-left: 8px solid #3E86A0;
            right: -15px;
          }
        }
      }
    }




  }
  .left-st{
    /deep/.tree_box{
      .tree_wrapper{
       .el-tree-node__content{
        height: 38px;
      }
    }

    }
    /deep/.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
      background: #49a4f0;
      color: white;
      font-weight: bold;
      /*border-radius: 25px;*/
      /*border-bottom-left-radius: 25px;*/
      position: relative;

    }
    /deep/.tree_box .tree_wrapper{
      padding-right: 0!important;

    }
  }

  .list-warp{
    >ul{
      width: 100%;
      >.detail-item {
        margin-bottom: 20px;
        padding: 20px;
        background: #f7f7f7;
        color: #333333;
        font-size: 16px;
        >ul{
          width: 100%;
          >li{
            width: 100%;
            padding: 7px 0;
            >.rights-label{
              width: 85px;
              float: left;
              color: #7c7857;
                font-size:  16px!important;
            }
            >.rights-con{

              float: left;
              width: calc(100% - 95px);
              &.rights-con-l{
                letter-spacing: 1px;
              }
            }
            >.serve-listul{
              background: white;
              padding:0 15px;
              color: #49A4F0;
              li{
                border-bottom:1px dashed #ccc;
                padding: 7px 0;
                &:hover  .pro-btn{
                  display: block;
                }
                &:last-child{
                  border-bottom:none;
                }

              .pro-name{
                font-size: 16px;
                font-family: PingFang SC;
                height: 36px;
                line-height: 36px;
              }
              .pro-btn {
                padding: 6px 0;
                display: none;
                > span {

                  display: inline-block;
                  border: 1px solid #49A4F0;
                  font-size: 14px;
                  width: 70px;
                  height: 26px;
                  line-height: 26px;
                  text-align: center;
                  margin-right: 20px;
                  cursor: pointer;
                  background: #DAE9F9;
                  &.disabled{
                    background: #F7F7F7;
                    cursor: not-allowed;
                    border: 1px solid #F7F7F7;
                    cursor:not-allowed;
                    color: #ccc;
                  }
                }
              }
              }
            }
          }
        }

      }
    }

  }
</style>
<style lang="less">

  .serve-center{
    .el-input--suffix{
      input{
        border: none;
        background: #F7F7F7;
        border-radius: 0px;
      }
    }
  }
  .dept-item {
    display: inline-block;
    margin: 0 10px 5px 10px;
    height: 38px;
    line-height: 38px;
    background: #f1f2f3;
    cursor: pointer;
    width: 130px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.active {
      background: #49a4f0;
      color: #ffffff;
      font-weight: bold;
    }
  }

.content-str img{
  max-width: 100%;
}

</style>
